import { render, staticRenderFns } from "./FttxOrderModal.vue?vue&type=template&id=000b94c0&scoped=true&"
import script from "./FttxOrderModal.vue?vue&type=script&lang=js&"
export * from "./FttxOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./FttxOrderModal.vue?vue&type=style&index=0&id=000b94c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b94c0",
  null
  
)

export default component.exports